// Action types for project management
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS';
export const SET_INTAKE_PROJECT_DETAILS = 'SET_INTAKE_PROJECT_DETAILS';
export const SET_PROJECT_LOADING = 'SET_PROJECT_LOADING';
export const SET_PROJECT_ERROR = 'SET_PROJECT_ERROR';
